import moment from 'moment';

const CrawlHistoryColumns = [
  {
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    slot: 'status',
    sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
  },
  {
    title: 'Domains',
    dataIndex: 'domains',
    width: 250,
    slot: 'domains',
    sorter: (a, b) => ((a.domains || []).length || a.total_jobs || 0) - ((b.domains || []).length || b.total_jobs || 0),
  },
  {
    title: 'Depth',
    dataIndex: 'max_depth',
    width: 80,
    sorter: (a, b) => (a.max_depth || 0) - (b.max_depth || 0),
  },
  {
    title: 'Depth Mode',
    dataIndex: 'depth_mode',
    width: 110,
    slot: 'depth_mode',
  },
  {
    title: 'Page Limit',
    dataIndex: 'page_limit',
    width: 100,
    sorter: (a, b) => (a.page_limit || 0) - (b.page_limit || 0),
  },
  {
    title: 'URL Report',
    dataIndex: 'url_report_mode',
    width: 130,
    slot: 'url_report_mode',
  },
  {
    title: 'Progress',
    dataIndex: 'completed_jobs',
    width: 120,
    slot: 'progress',
    sorter: (a, b) => (a.completed_jobs || 0) - (b.completed_jobs || 0),
  },
  {
    title: 'Created',
    dataIndex: 'created_at',
    width: 170,
    slot: 'created_at',
    sorter: (a, b) => moment(a.created_at).diff(moment(b.created_at)),
  },
  {
    title: 'Completed',
    dataIndex: 'completed_at',
    width: 170,
    slot: 'completed_at',
    sorter: (a, b) => {
      if (!a.completed_at && !b.completed_at) return 0;
      if (!a.completed_at) return -1;
      if (!b.completed_at) return 1;
      return moment(a.completed_at).diff(moment(b.completed_at));
    },
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation',
  },
];

export { CrawlHistoryColumns };
